import React from 'react';
import Radio from 'apollo-react/components/Radio';

/**
 * Formik field radio, or standalone when `field` is omitted: pass `checkedValue` + `groupName`.
 */
const RadioInput = ({
  field,
  meta,
  label,
  value,
  onChange,
  required,
  /** Current value for the whole group (standalone mode, no Formik `field`). */
  checkedValue,
  /** Shared `name` for grouped radios when `field` is omitted. */
  groupName,
}) => {
  const mergedMeta = meta ?? { touched: false, error: undefined };
  const selected = field != null ? field.value : checkedValue;

  return (
    <Radio
      {...(field || {})}
      name={field?.name ?? groupName ?? 'radio-input-group'}
      label={label}
      value={value}
      checked={selected === value}
      onChange={(e) => {
        const v = e.target.value;
        if (onChange) {
          onChange(v);
        } else if (field?.onChange) {
          field.onChange(e);
        }
      }}
      error={mergedMeta.touched && !!mergedMeta.error}
      required={required}
      helperText={
        mergedMeta.touched && mergedMeta.error ? mergedMeta.error : ''
      }
    />
  );
};

export default RadioInput;
